import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import KshemaLogo from '../assets/img/kshema_logo.svg';
import Image from 'react-bootstrap/Image';
import '../assets/style/SideNav.css';
import SubMenu from './SubMenu';
import {
  dashboardSelector,
  updateSelectedMenu,
  updateSideMenuStatus,
} from '../features/dashboardSlice';
import { LoggedUserType, SideMenuItemType } from '../utils/Types';
import { RABC } from '../utils/RBAC';
import { loginSelector } from '../features/loginSlice';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import { SIDE_MENU_STATUS } from '../utils/Constant';
import CloseIcon from '../assets/img/close.svg';

const SideNav = () => {
  const [isOpen, setIsOpen] = useState(true);
  const dashboardState = useAppSelector(dashboardSelector);
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const dispatch = useAppDispatch();

  useEffect(() => {
    setIsOpen(dashboardState.isOpenSideMenu);
  }, [dashboardState.isOpenSideMenu]);
  const toggle = () => {
    //auto close side for mobile on selecting the
    if (window.innerWidth <= 480) {
      setIsOpen(!isOpen);
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.CLOSE));
    }
  };
  const dashboardItems = RABC.map((item: SideMenuItemType, index: number) => {
    return (
      <div key={`key-${item.route}`}>
        {item.submenu &&
          item.submenuItems &&
          item.roles &&
          item.roles.includes(user.roleId) && (
            <SubMenu
              key={`submenu-${item.route}-${index}`}
              title={item.title}
              icon={item.icon}
              items={item.submenuItems}
              parentKey="user-onboarding"
              onSelected={toggle}
            />
          )}
        {!item.submenu && item.roles && item.roles.includes(user.roleId) && (
          <NavItem key={`${item.route}-${index}`}>
            <NavLink
              tag={Link}
              to={item.route}
              onClick={() => {
                dispatch(updateSelectedMenu(item.route));
                toggle();
              }}
              className={`align-middle ${
                dashboardState.selectedMenu === item.route
                  ? 'nav-selected'
                  : 'nav-unselected'
              }`}
            >
              <Image src={item.icon} alt="icon" className="icon" />
              {item.title}
            </NavLink>
          </NavItem>
        )}
      </div>
    );
  });

  return (
    <div className={`sidenav ${isOpen ? 'open' : ''}`}>
      <div className="d-flex flex-row-reverse">
        <Image
          src={CloseIcon}
          className="close-icon align-self-end menu"
          onClick={toggle}
        />
      </div>
      <Nav vertical color="light" expand="md">
        <div className="text-center">
          <Image src={KshemaLogo} alt="img" className="logo-header" />
        </div>
        {dashboardItems}
      </Nav>
    </div>
  );
};

export default SideNav;
